import {Reducer} from 'redux';
import {LOGGED_IN, LOGGED_OUT, LoggedInUserState, LoginActionTypes} from '../action/loginAction';

const initialState: LoggedInUserState = {
    requested: false,
    loggedIn: false
};

const loginReducer: Reducer<LoggedInUserState, LoginActionTypes> = (state = initialState, action) => {
    switch (action.type) {
        case LOGGED_IN: {
            return {
                requested: true,
                loggedIn: true,
                userData: action.payload
            };
        }

        case LOGGED_OUT: {
            return {
                requested: true,
                loggedIn: false,
                userData: undefined
            };
        }
    }
    return state;
};

export default loginReducer;
